import {useSyncExternalStore} from "react";

/*
* Nothing ever changes, so no subscriber is needed - the value only differs between the server
* snapshot and the client snapshot.
* */
const subscribe = () => () => {
};
const getClientSnapshot = () => true;
const getServerSnapshot = () => false;

/*
* Returns false for the server render and for the hydrating client render, then true once React has
* hydrated the component on the client.
*
* Use this for styling that is only meant to bridge the gap between the server-rendered HTML and
* the moment client-side code takes over - e.g. a component whose real visibility is applied by an
* effect, which means the raw server HTML would paint wrong until that effect has run. Returning
* the server value for the hydrating render keeps hydration free of mismatches.
* */
const useIsHydrated = (): boolean =>
    useSyncExternalStore(subscribe, getClientSnapshot, getServerSnapshot);

export default useIsHydrated;